import React from 'react'

const MenuItemsComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default MenuItemsComponent
